module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/4@2x_527a918ef3674b2cf2858eb3780fe5bb.png";